// extracted by mini-css-extract-plugin
export default {"main":"_3M-_JLavo3M6gVoALax19y"};